import { render, staticRenderFns } from "./AddUserToProduct.vue?vue&type=template&id=f75bc2d8&scoped=true"
import script from "./AddUserToProduct.vue?vue&type=script&lang=js"
export * from "./AddUserToProduct.vue?vue&type=script&lang=js"
import style0 from "./AddUserToProduct.vue?vue&type=style&index=0&id=f75bc2d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f75bc2d8",
  null
  
)

export default component.exports